import merge from 'lodash/merge'
import { SET_PRECHECK_TIME } from '../actions/setPreCheckTimeActions'

const initialState = {
}

export default function preCheckTimeReducer(state = initialState, action) {
	switch(action.type) {

		case SET_PRECHECK_TIME:
			// set grouped pre check-in time
			return merge({}, state, action.payload)

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/preCheckTimeReducers.js